module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "system"
  }, [_c('banner', {
    attrs: {
      "clazz": "system-banner",
      "url": "system",
      "hasDivider": ""
    }
  }, [_c('template', {
    slot: "buttons"
  }, [_c('el-button', {
    staticClass: "banner-button",
    attrs: {
      "round": ""
    },
    on: {
      "click": function($event) {
        return _vm.goMore('neibujicheng-banner-tiyan')
      }
    }
  }, [_vm._v("申请体验")]), _vm._v(" "), _c('el-button', {
    staticClass: "banner-button",
    attrs: {
      "round": ""
    },
    on: {
      "click": this.goConsult
    }
  }, [_vm._v("立即咨询")])], 1)], 2), _vm._v(" "), _c('div', {
    staticClass: "system-section1"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "section1-content"
  }, [_c('img', {
    staticClass: "section1-img",
    attrs: {
      "src": require("../../assets/img/system/peitu.png"),
      "alt": "内部系统集成"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "section1-misc"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "misc-divider"
  }), _vm._v(" "), _c('p', {
    staticClass: "misc-content"
  }, [_vm._v("甄云SRM提供开放的接口平台，旨在集成企业ERP系统、OA/BPM等内部管理系统。主流ERP系统如SAP、Oracle ERP、用友、金蝶等均提供通用接口，数百家客户成功实施验证。开放接口平台将原本分散在各系统的采购数据传输整合，按需分配，有效消除部门间，企业与上有供应商的信息孤岛。降低生产成本，扩大经济效益。")]), _vm._v(" "), _c('hover-button', {
    attrs: {
      "clazz": "consult-button",
      "text": "立即咨询"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.goConsult.apply(null, arguments)
      }
    }
  })], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "system-section2"
  }, [_c('div', {
    staticClass: "item-list"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "item-tab"
  }, [_c('el-tabs', {
    attrs: {
      "type": "border-card",
      "stretch": ""
    }
  }, [_c('el-tab-pane', {
    attrs: {
      "label": "统一入口"
    }
  }, [_c('div', {
    staticClass: "rel clearfix content"
  }, [_c('div', {
    staticClass: "fl left-list"
  }, [_c('h2', {
    staticClass: "title"
  }, [_vm._v("统一入口")]), _vm._v(" "), _c('div', {
    staticClass: "border-bottom-tab"
  }), _vm._v(" "), _c('p', {
    staticClass: "left-desc"
  }, [_vm._v("\n                  通过甄云SRM采购管理平台为用户提供统一的信息系统登录入口，可以直接进入其它信息系统，不必再输入用户名/密码，很大程度上为企业用户登录各项信息系统提供了方便。同时为企业建立了一个统一的协同工作平台。\n                ")])]), _vm._v(" "), _c('div', {
    staticClass: "fr rel right-list"
  }, [_c('div', {
    staticClass: "right-img"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/img/system/peitu1.png"),
      "alt": "统一入口"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "abs right-bg rbg01"
  })])])]), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "信息交互"
    }
  }, [_c('div', {
    staticClass: "clearfix content"
  }, [_c('div', {
    staticClass: "fl left-list"
  }, [_c('h2', {
    staticClass: "title"
  }, [_vm._v("信息交互")]), _vm._v(" "), _c('div', {
    staticClass: "border-bottom-tab"
  }), _vm._v(" "), _c('p', {
    staticClass: "left-desc"
  }, [_vm._v("\n                  通过甄云集成平台，将其它系统的部分信息数据引用、推送到甄云SRM，方便采购员及时查阅和处理。 例如：送发货信息、未读邮件、数据报表、费用支付等各类信息。这些集成应用将原本分散的数据信息传输整合，按需分配，有效消除企业信息孤岛。\n                ")])]), _vm._v(" "), _c('div', {
    staticClass: "fr rel right-list"
  }, [_c('div', {
    staticClass: "right-img"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/img/system/peitu2.png"),
      "alt": "信息交互"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "abs right-bg rbg02"
  })])])]), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "资源整合"
    }
  }, [_c('div', {
    staticClass: "clearfix content"
  }, [_c('div', {
    staticClass: "fl left-list"
  }, [_c('h2', {
    staticClass: "title"
  }, [_vm._v("资源整合")]), _vm._v(" "), _c('div', {
    staticClass: "border-bottom-tab"
  }), _vm._v(" "), _c('p', {
    staticClass: "left-desc"
  }, [_vm._v("\n                  内部系统的集成，便于知晓社会竞争态势，比对供应商发货时间和速度优劣来实现企业资源重组优化，很大程度上改善了传统企业采购资金、物流、信息运转较慢的状况，去除了中间不必要的繁杂环节，降低了企业采购成本，并在一定程度上提升了企业面对突发状况的应变能力。\n                ")])]), _vm._v(" "), _c('div', {
    staticClass: "fr rel right-list"
  }, [_c('div', {
    staticClass: "right-img"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/img/system/peitu3.png"),
      "alt": "资源整合"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "abs right-bg rbg03"
  })])])])], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "item-list2"
  })])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "misc-title"
  }, [_c('p', [_vm._v("内部系统集成")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tc"
  }, [_c('h1', {
    staticClass: "item-list-title"
  }, [_vm._v("内部系统集成平台特色")]), _vm._v(" "), _c('div', {
    staticClass: "dib tl border-bottom"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-fe142c56"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/product/system.vue
// module id = 540
// module chunks = 12